import { QueryOption } from '../@types';
import { MerchantDamagePartAdditionalData, MerchantDamageTemplateQuery } from '../@types/part.type';
import { httpClient, HttpMethod } from './http-client';

export const getAllParts = (queryOptions: QueryOption, serialSearch?: string, excludedColumns?: string, obfuscation?: string) => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/parts?page=${page + 1}&limit=${pageSize}&serial_search=${serialSearch}&excludedColumns=${excludedColumns}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel.items?.forEach((filter: any) => {
    url += `&${filter?.columnField || filter?.field}=${filter?.operatorValue || filter?.operator},${filter.value}`;
  });
  
  if (obfuscation) {
    url += `&obfuscation=${obfuscation}`;
  }

  return httpClient(url, HttpMethod.Get, null);
};

export const getNSPartByPartTypeAndLocation = (partTypeId: number, locationId: number, isReturn: boolean = false, isIncludeLocationChildren: boolean = false) => {
  return httpClient(`/nsparts/search?partTypeId=${partTypeId}&locationId=${locationId}&isReturn=${isReturn}&isIncludeLocationChildren=${isIncludeLocationChildren}`, HttpMethod.Get, null);
};

export const getPartsLogAgainstService = (serviceId: number, locationTypeCode: string) => {
  return httpClient(`/partsLogAgainstService/${serviceId}?locationTypeCode=${locationTypeCode}`, HttpMethod.Get, null);
};

export const getMerchantDamagePartSerialData = (queryOptions: MerchantDamageTemplateQuery) => {
  const { serviceId, mainLocationNodeId } = queryOptions;
  const url = `/partHistory/${serviceId}/location/${mainLocationNodeId}/outPartActions`;
  return httpClient(url, HttpMethod.Get, null);
};

export const updatePartAdditionalData = (queryOptions: MerchantDamagePartAdditionalData, partId: number) => {
  const url = `/parts/${partId}/additionalData/merchantDamageData`;
  return httpClient(url, HttpMethod.Put, queryOptions);
};